import React, { createContext, useReducer, useContext } from "react";
import {
  GlobalState,
  GlobalAction,
  ActionTypes,
  GlobalContextProps,
} from "./models";
import { Contract } from "#/types";

export const initialState: GlobalState = {
  selectedProduct: undefined,
  contract: undefined,
  products: undefined,
  isLoading: false,
};

const Context = createContext({} as GlobalContextProps);

const reducer = (state: GlobalState, action: GlobalAction): GlobalState => {
  switch (action.type) {
    case ActionTypes.SET_LOADING: {
      return { ...state, isLoading: action.payload };
    }
    case ActionTypes.SET_PRODUCTS: {
      return { ...state, products: action.payload };
    }
    case ActionTypes.SET_PRODUCT: {
      return { ...state, selectedProduct: action.payload };
    }
    case ActionTypes.SET_CONTRACT: {
      return { ...state, contract: action.payload };
    }
    case ActionTypes.DELETE_DEPENDENT: {
      const contract = state.contract as Contract;
      return {
        ...state,
        contract: {
          ...contract,
          dependents:
            contract.dependents?.filter(
              (dep, index) => dep.insurance.code !== action.payload
            ) ?? [],
        },
      };
    }
    default: {
      throw new Error(`Unsupported action type: ${action}`);
    }
  }
};

type InitialState = {
  globalState?: GlobalState;
};

export const GlobalContextProvider: React.FunctionComponent<InitialState> = ({
  children,
  globalState = initialState,
}: any) => {
  const [state, dispatch] = useReducer(reducer, globalState);
  const value = { state, dispatch } as GlobalContextProps;
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export function GlobalContext() {
  const { state, dispatch } = useContext(Context);
  return { state, dispatch, ActionTypes };
}
